import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import AddAdminIndividual from './AddAdminIndividualCourse';
import AddSellerIndividual from './AddSellerIndividualCourse';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';

export default function ScheduleIndex(props) {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <AddAdminIndividual {...props} />
			break;
		case '2':
			component = <AddSellerIndividual {...props} />
			break;
		case '3':
			component = <AddSellerIndividual {...props} />
			break;
		default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
